import React from "react";
import { Alert as MaterialAlert, AlertTitle as MaterialAlertTitle } from '@material-ui/lab';

const Alert = ({className, severity, title, message}) => {
  return (
    <MaterialAlert
      className={className}
      severity={severity}
    >
      <MaterialAlertTitle>{title}</MaterialAlertTitle>
      {message}
    </MaterialAlert>
  );
};
export default Alert;
